import React from 'react';
import { Carousel } from '../../components/Carousel';
import PaginationArrow from '../../components/Carousel/PaginationArrow';
import PaginationArrowDots from '../../components/Carousel/PaginationArrowDots';
import {
  fontHeading2
} from '../../styles/typographyNew';
import { classNames } from '../../utils/style';
import { useScreenSize } from '../../utils/utils';
import { CarouselCard } from './CarouselCard';

export interface HowItWorkCarouselProps {
  content: any;
  isDark?: boolean;
  type?: any;
  title?: string;
  classNameContainer?: string;
  isLoop?: boolean;
  isAutoplay?: boolean;
  className?: string;
}

export const HowItWorkCarousel = ({
  content,
  isDark,
  type,
  title,
  classNameContainer,
  isLoop,
  isAutoplay,
  className,
}: HowItWorkCarouselProps) => {
  const screensize = useScreenSize();
  const isMobile = ['xs', 'sm', 'md', 'lg'].includes(screensize);

  return (
    <div className={'HowItWorkCarousel'}>
      {title && (
        <h2
          className={classNames(
            fontHeading2,
            'flex mb-40 text-center w-[300px] text-neutral-301 font-semibold',
            'mx-auto md:justify-center md:w-auto lg:ps-[calc(50%-1024px/2)]',
            'xl:absolute xl:ps-[calc(50%-1202px/2)] xl:text-justify',
          )}
        >
          {title}
        </h2>
      )}
      <Carousel
        isItemsCentered={isMobile}
        isSurrounded={isMobile}
        classNameCarousel={'gap-[20px]'}
        classNameSlide="rounded-[24px]"
        paginationPosition={isMobile ? 'bottom' : 'top'}
        initialSelected={0}
        pagination={[
          <PaginationArrow
            isItemsCentered={isMobile}
            className="hidden mb-48 xl:flex xl:max-w-[1202px] xl:mx-auto xl:w-full"
            numberHidden
            key="0"
          />,
          <PaginationArrowDots
            isItemsCentered
            className="xl:hidden mt-24"
            key="1"
          />,
        ]}
        {...{
          isDark,
          type,
          classNameContainer: `${classNameContainer}`,
          isLoop,
          isAutoplay,
          className,
        }}
      >
        {content?.map((cardProps: any, key: number) => {
          return <CarouselCard key={key} cardIndex={key} {...cardProps} />;
        })}
      </Carousel>
    </div>
  );
};
